import request from "@/utils/request";

export default function adminOpenCloseNewsMessage(id,state,messageTemplateId) {
    return request({
        url: `/news/agencyOpenCloseNewsMessage/`+id+`/`+state+`/`+messageTemplateId,
        method: 'get',
    })
}
